var AddressBillingForm = (function (CheckoutApiCollection, Decoration, PromiseUtil, CheckoutSettings) {
    return CheckoutApiCollection.extend({
        model: Decoration,

        initialize: function () {
            this._saving = null;
            this.$ready = new $.Deferred();
        },

        save: function () {
            if (this._saving) {
                return this._saving.promise();
            } else if (!this.isValid()) {
                window.app && app.event && app.event.addressValidation(0);
                return PromiseUtil.rejected();
            }

            window.app && app.event && app.event.addressValidation(1);

            var address = {};

            this.each(function (m) {
                address[m.get('Name')] = m.getHidden() === true ? '' : m.get('Value');
            });

            this._saving = this._api.setUserBillingAddress(address);

            setTimeout(_.bind(function () {
                this._saving.done(_.bind(this._updateCheckout, this))
                    .always(_.bind(function () {
                        this._saving = null;
                    }, this));
            }, this), 0);

            return this._saving.promise();
        },

        isValid: function () {
            var isValid = true;

            this.each(function (model) {
                isValid &= model.isValid();
            });

            this.trigger('isValid', isValid);
            return isValid;
        },

        isActive: function () {
            return this._isActive;
        },

        setActive: function (isActive) {
            this._isActive = isActive;
            this.trigger('isActive', isActive);
        },

        setDecoration: function (decoration, currentAddress) {
            if (!this.__ready) {
                this.__ready = true;
                if (!currentAddress) {
                    this._api.getUserAddresses()
                        .done(_.bind(function(data) {
                            var list = data && data.Value && data.Value.AddressesList || [];
                            var address = list[0] || null;
                            if (address && (!address.ID || address.ID === '00000000-0000-0000-0000-000000000000')) {
                                address = null;
                            }
                            this._setDecoration(address);
                        },  this));
                } else {
                    this._setDecoration(currentAddress);
                }
            }
        },

        _setDecoration: function (currentAddress) {
            var list = [];
            var decoration = CheckoutSettings.getDecoration();
            currentAddress = currentAddress || {};
            _.each(decoration.Billing, function (field) {
                var fieldName = field.Name;
                var value = currentAddress && currentAddress[fieldName] || '';
                var copyField = { Value: value || '' };
                list.push(_.extend({}, field, copyField));
            });

            this.update(list);
            this.$ready.resolve();
        },

        ready: function(cb) {
            this.$ready.done(cb);
        }

    });
})(CheckoutApiCollection, Decoration, PromiseUtil, CheckoutSettings);
